import { mapActions, mapState } from 'vuex'
import AppointmentService from '../../../../services/appointment/appointmentService'
import serviceUser from '../../../../services/user/UserService'
const holidaysApi = require('colombia-holidays');


export default {
    props: ['providerId'],
    data() {
        return {
            statesData: [],
            citiesData: [],
            scheduleRangeData: [],
            state: null,
            city: null,
            range: null,
            branch: null,
            shippingDate: {},
            scheduleRange: null,
            observation: null,
            cityIsLoading: false,
            cellPhone: null,
            minDate: {},
            notAllowedDays: [0],
            monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            dayNames: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
            holidays: [],
            branches: [],
            addressBranch: '',
            idBranches: '',
            idBranch: '',
            enabledDays: [],
            formattedDate: ''
        }
    },

    created() {
        this.getStates()
        const today = new Date()
        if ((today.getDay()) === 7) {
            this.shippingDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3)
            this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3)
        } else if (today.getDay() === 6) {
            this.shippingDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3)
            this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3)
        } else if (today.getDay() === 0) {
            this.shippingDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3)
            this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3)
        } else {
            this.shippingDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2)
            this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2)
        }

        let holidaysAux = holidaysApi.getColombiaHolidaysByYear(today.getFullYear());
        for (let i = 0; i < holidaysAux.length; i++) {
            const holiday = holidaysAux[i];
            const input = holiday.holiday.split('-')
            let dateAux = new Date(input[0], input[1] - 1, input[2])
            this.holidays.push(dateAux)
        }
    },

    computed: {
        ...mapState('delivery', {
            provider: 'provider'
        }),
        ...mapState('auth', [
            'user',
            'identification',
            'identificationType'
        ]),

        isNextButtonDisable() {
            return (this.scheduleRange === null || this.scheduleRange === undefined && this.shippingDate == null || this.shippingDate == undefined)
        }

    },

    watch: {
        state() {
            this.getCities()
        },

        city() {
            this.getCities()
            this.branchesAppointment()
        },
    },

    methods: {
        contains(arr, id) {
            return arr.some(e => e.id === id)
        },

        async getStates() {
            try {
                const response = await AppointmentService.statesAppointment()
                this.statesData = response.data
            } catch (error) {
            }
        },

        async getCities() {
            try {
                this.cityIsLoading = true
                const result = await AppointmentService.cityAppointment(this.state)
                this.citiesData = result.data
                this.cityIsLoading = false
            } catch (error) {
                this.cityIsLoading = false
            }
        },


        async branchesAppointment() {
            let branch = [];
            const response = await AppointmentService.getBranchesAppointment(this.city)
            const branches = response.data

            branches.forEach(branche => {
                branche.idDeliveryPoint.idBranch = branche.id;
                branch.push(branche.idDeliveryPoint)

            });
            this.idBranches = branch
            this.branches = branch.map((namePharmacys) => {
                return { name: namePharmacys.name, id: namePharmacys.id, address: namePharmacys.address }
            })

        },
        getAddress() {
            let aux = this.branches.find(branch => branch.id == this.branch)
            this.addressBranch = aux.address
            this.getDayAttentionByBranch()
        },

        async getDayAttentionByBranch() {
            let idBranchAux = this.idBranches.find(branch => branch.id == this.branch)
            this.idBranch = idBranchAux.idBranch
            const response = await AppointmentService.getDayAttentionByBranch(this.idBranch)

            let data = response.data

            for (let i = 0; i < data.length; i++) {
                this.enabledDays.push(new Date(data[i].idCapacity.Day))
            }
        },

        async getDayAppointment() {
            let formattedDate = this.shippingDate.toISOString().substring(0, 10)
            this.formattedDate = formattedDate.replace("T", " ").replace("Z", "")
            this.getScheduleRanges()
        },

        async getScheduleRanges() {
            const response = await AppointmentService.getCalendarAppointment(this.idBranch, this.formattedDate)

            this.scheduleRangeData = response.data
        },

        ...mapActions(
            'delivery',
            [
                'setShippingDate',
                'setState',
                'setCity',
                'setSchedule',
                'setScheduleName',
                'setObservations',
                'setBranch',
                'setBranchName',
                'setBranchAddress'
            ]
        ),
        async nextPage() {
            if (this.shippingDate) this.setShippingDate(this.shippingDate)
            if (this.state) this.setState(this.state)
            if (this.city) this.setCity(this.city)
            if (this.branch) {
                const branch = this.branches.find(branch => branch.id == this.branch)
                this.setBranch(branch.id)
                this.setBranchName(branch.name)
                this.setBranchAddress(branch.address)
            }
            let response = await serviceUser.prioritizedPatient(this.identification, this.identificationType)
            let patient = response.data
            if (patient) {
                this.shippingFee = 0
            }
            if (this.shippingFee) this.setShippingFee(this.shippingFee)
            if (this.scheduleRange) {
                const scheduleRange = this.scheduleRangeData.find(scheduleRange => scheduleRange.id == this.scheduleRange)
                this.setSchedule(scheduleRange.id)
                this.setScheduleName(scheduleRange.attentionHours)
            }
            if (this.observation) this.setObservations(this.observation)
            this.$emit('nextStep')
        }
    }
}